module.exports = __webpack_public_path__ + "assets/7c6513fce6bab58780887470b84830e9.json";